import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./appSlice"; // Adjust the import path

const store = configureStore({
  reducer: {
    appSlice: appReducer,
  },
});

export default store;
